import gql from 'graphql-tag'

const updateClientiUI = gql`
  mutation updateClientiUI($clientiUI: ClientiUI!) {
    updateClientiUI(clientiUI: $clientiUI) @client {
      sortFields
      searchQuery
      searchQueryDebounced
      onlyDaRicontattare
      zona
      interesse
      zonaEsclusa
      interesseEscluso
      page
    }
  }
`

export default updateClientiUI



// WEBPACK FOOTER //
// ./src/graphql/mutations/updateClientiUI.js